import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { LcsExpansionPanelModule } from '@lcs/shared/expansion-panel';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { PrivilegeListComponent } from './privileges-list.component';

@NgModule({
   declarations: [PrivilegeListComponent],
   exports: [PrivilegeListComponent],
   imports: [
      CommonModule,
      RouterModule,
      FormsModule,
      MatFormFieldModule,
      MatCheckboxModule,
      ReactiveFormsModule,
      LcsExpansionPanelModule,
      MatInputModule,
      MatIconModule,
      AddSpacesPipeModule,
   ],
})
export class PrivilegeListModule {}
